<template>
  <div
    v-auto-focus
    v-swipe="handleSwipe"
    data-test="image-dialog"
    class="
      relative flex justify-center items-center bg-black/75! outline-none will-change-scroll
      touch-none h-screen! w-screen! max-w-[100vw]! max-h-screen! mx-auto px-[5%]! my-0!
    "
    tabindex="0"
    @keydown.esc="closeDialog"
    @keydown.right="next"
    @keydown.left="prev"
  >
    <div
      class="flex w-full h-full justify-center"
    >
      <wui-btn
        :size="32"
        icon
        prepend-icon="navigatePrev"
        class="fixed left-0 top-1/2 h-8! rounded-12! text-surf-lock-wht! hover:bg-surf-lock-wht/15!"
        @click.stop="prev"
      />
      <picture
        v-touch-resize
        class="object-contain p-4 touch-none"
        @click.stop
      >
        <a
          id="img-source"
          :download="name"
          class="h-full w-full flex items-center"
        >
          <img
            v-click-outside="closeDialog"
            :alt="$t('common.picture')"
            :src="getAuthenticatedMediaUrl(src)"
            class="w-full h-auto object-contain"
            @click.prevent.stop="onClick"
          >
        </a>
      </picture>
      <wui-btn
        :size="32"
        icon
        prepend-icon="navigateNext"
        class="fixed right-0 top-1/2 h-8! rounded-12! text-surf-lock-wht! hover:bg-surf-lock-wht/15! outline-none!"
        @click.stop="next"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { closeDialogKey, ClickOutside as vClickOutside, safeInject, WuiBtn } from '@wui/common-library'

import { AutoFocus as vAutoFocus } from '@/shared/directives/auto-focus'
import { vSwipe, SwipeDirection } from '@/shared/directives/v-swipe'
import { vTouchResize } from '@/shared/directives/v-touch-resize'
import { getAuthenticatedMediaUrl } from '@/shared/utils/url'

import { useNavigateItems } from './use-navigate-items'

const props = defineProps<{
  src: string
  name: string
}>()

const { nextPicture, prevPicture } = useNavigateItems()

const closeModal = safeInject(closeDialogKey)
const next = () => {
  nextPicture(props.src, closeModal)
}

const prev = () => {
  prevPicture(props.src, closeModal)
}

const handleSwipe = (direction: SwipeDirection) => {
  if (direction === 'right') {
    next()
  } else if (direction === 'left') {
    prev()
  }
}
const closeDialog = () => {
  closeModal(undefined)
}

const onClick = (event: MouseEvent) => {
  const offsetFromCenter = document.body.clientWidth / 2 - event.pageX

  if (offsetFromCenter > 0) {
    prev()
  } else {
    next()
  }
}
</script>
